export default __webpack_public_path__ + "static/media/icon-coin-dog.273ed1d8.svg";